import script from "./BgVideoWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./BgVideoWrapper.vue?vue&type=script&setup=true&lang=js"

import "./BgVideoWrapper.vue?vue&type=style&index=0&id=7e7992f0&scoped=true&lang=css"

import exportComponent from "/Users/jonathan/Projects/kubiek/kronenburg/web/themes/custom/ef2_custom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7992f0"]])

export default __exports__